import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Sempre usar tema claro
  const isDark = false;

  useEffect(() => {
    // Garantir que a classe 'dark' nunca seja aplicada
    document.documentElement.classList.remove('dark');
    // Forçar tema claro no localStorage
    localStorage.setItem('theme', 'light');
  }, []);

  const toggleTheme = () => {
    // Função vazia - tema claro sempre ativo
  };

  const value = {
    isDark,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

